import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Transaction from '../../entities/transaction';
import Invoice from '../../entities/invoice';
export function deleteTransaction(transaction: Transaction, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = transaction.id;}
const _work = workingSet();




transaction.status = 'D';
transaction.addedOn = newHRTimestamp();
transaction.addedBy = getCurrentUserId();
transaction.importSource = targetImportSource;
transaction.importId = mergeId;
store.dispatch(Actions.TransactionActions.removeTransactionQueue(transaction));
}

export function deleteImpactTransaction(transaction: Transaction) {
const impacts: string[] = [];
const state = store.getState();
const invoiceTransactionIdsImpact = state.invoices.getMappingFor('transactionIds', transaction.id).filter(invoice => invoice.status !== 'D');
invoiceTransactionIdsImpact.forEach(() => impacts.push('invoices'));



return util.countDistinct(impacts);
}
